import { NavigateFunction } from 'react-router-dom';

const History: { navigate: NavigateFunction } = {
  navigate: (() => {}) as NavigateFunction,
};

export default History;
